module.exports = __webpack_public_path__ + "static/media/collaboration-meeting.b17eb68c.jpg";